export default  {

    user_show:"/blog/:username/:id",
    show_by_title:'/blog/:title'
}